// extracted by mini-css-extract-plugin
module.exports = {"Part":"Part_Part__9Di2y","Info":"Part_Info__2GUyK"};